<template>
  <b-modal
    id="change-team-manager-modal"
    :ok-title="trans('change')"
    :ok-disabled="!canChange"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onChange"
  >
    <template #modal-title>
      {{ trans('change_team_manager') }}
      <span v-if="!!teamAndRoster">- {{ teamAndRoster.name }}</span>
      <small v-if="!!teamAndRoster" class="text-muted ml-2">
        # {{ teamAndRoster.id }}
      </small>
    </template>

    <b-form-group :label="trans('manager')">
      <b-form-select
        v-model="recipient_id"
        :options="options"
        :disabled="busy"
      ></b-form-select>
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      teamAndRoster: Object,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        recipient_id: null,
      }
    },
    computed: {
      players() {
        if (!this.teamAndRoster || !this.teamAndRoster.players) return []
        return this.teamAndRoster.players
      },
      currentManagerEmail() {
        return !!this.teamAndRoster && !!this.teamAndRoster.manager ?
          this.teamAndRoster.manager.email :
          null
      },
      options() {
        return _.map(this.players, player => {
          return {
            // Note - we always try to use the account owner recipient. If there is no invoice, use the player.
            value: player.invoice_recipient_id || player.id,
            text: _.compact([player.name, player.email]).join(', '),
          }
        }, [])
      },
      canChange() {
        return !!this.recipient_id
      },
    },
    methods: {
      onShown() {
        // Note - we always try to use the account owner recipient. If there is no invoice, use the player.
        if (!!this.currentManagerEmail) {
          let player = _.find(this.players, {email: this.currentManagerEmail})
          if (player) this.recipient_id = player.invoice_recipient_id || player.id
        }
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.recipient_id = null
      },
      onChange(e) {
        e.preventDefault()

        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/team/${this.teamAndRoster.id}/manager/${this.recipient_id}`
        axios.put(url)
        .then(response => {
          this.busy = false
          this.$emit('changed', response.data)
          this.$bvModal.hide('change-team-manager-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.changeTeamManagerModal = this
    },
  }
</script>